let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kjPUS")).then(() => parcelRequire('6l95m'));